import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useUserAuth } from "@/contexts/UserAuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const nav = useNavigate();
  const { loginWithSessionId } = useUserAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      nav("/pet-record", { replace: true });
      return;
    }
    const sessionId = decodeURIComponent(m[1]);
    (async () => {
      try {
        await loginWithSessionId(sessionId);
        // Wipe the fragment so refresh doesn't re-exchange
        window.history.replaceState({}, document.title, "/pet-record");
        nav("/pet-record", { replace: true });
        toast.success("Welcome to Furshala!");
      } catch (e) {
        toast.error("Login failed — please try again.");
        nav("/pet-record", { replace: true });
      }
    })();
  }, [loginWithSessionId, nav]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-brand-cream text-brand-soft/70 text-sm" data-testid="auth-callback">
      Signing you in…
    </div>
  );
}
